export function convertStringToDate(dateString: string): Date | null {
  // This works for dates from the templates backend
  if (!dateString) {
    return null;
  }
  if (!dateString.endsWith('Z')) {
    dateString += 'Z';
  }
  return new Date(dateString);
}
